import React from "react";
import { useAuth } from "@/context/AuthContext";
import CustomerDashboard from "@/pages/CustomerDashboard";
import ManagerDashboard from "@/pages/ManagerDashboard";
import TechnicianDashboard from "@/pages/TechnicianDashboard";
import FranchiseeDashboard from "@/pages/FranchiseeDashboard";
import ContractCustomerDashboard from "@/pages/ContractCustomerDashboard";
import ManufacturerDashboard from "@/pages/ManufacturerDashboard";
import ForcedPasswordChange from "@/components/app/ForcedPasswordChange";

export default function Dashboard() {
  const { user } = useAuth();
  if (user?.must_change_password) return <ForcedPasswordChange />;
  if (user?.role === "manager") return <ManagerDashboard />;
  if (user?.role === "franchisee") return <FranchiseeDashboard />;
  if (user?.role === "technician") return <TechnicianDashboard />;
  if (user?.role === "contract_customer") return <ContractCustomerDashboard />;
  if (user?.role === "manufacturer") return <ManufacturerDashboard />;
  return <CustomerDashboard />;
}
